module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "vertical_message_box",
    attrs: {
      "id": "vertical_message_box"
    }
  }, [_c('van-pull-refresh', {
    on: {
      "refresh": _vm.loadMore
    },
    model: {
      value: (_vm.isLoading),
      callback: function($$v) {
        _vm.isLoading = $$v
      },
      expression: "isLoading"
    }
  }, [_c('div', {
    attrs: {
      "id": "ChatRoomContent"
    }
  }, _vm._l((_vm.chatRecord), function(item, index) {
    return _c('ul', {
      key: index,
      staticClass: "chatList"
    }, [(item.module == 'text_comment') ? _c('li', [_c('div', {
      staticClass: "chat_box"
    }, [_c('div', {
      staticClass: "img fl"
    }, [_c('img', {
      attrs: {
        "src": item.header
      }
    })]), _vm._v(" "), (item.module == 'text_comment') ? _c('div', {
      staticClass: "chat_info"
    }, [_c('span', {
      staticClass: "name"
    }, [_vm._v(_vm._s(item.nick) + ":")]), _vm._v(" "), (item.showzhu == 1) ? _c('span', {
      staticClass: "zhuTeacher"
    }, [_vm._v("老师")]) : _vm._e(), _vm._v(" "), _c('span', {
      directives: [{
        name: "dompurify-html",
        rawName: "v-dompurify-html",
        value: (item.content),
        expression: "item.content"
      }],
      staticClass: "chat_text"
    }), _vm._v(" "), (item.pic_url) ? _c('img', {
      staticStyle: {
        "max-width": "50%",
        "display": "block"
      },
      attrs: {
        "src": item.pic_url
      },
      on: {
        "load": _vm.imgOnload,
        "click": function($event) {
          return _vm.preview(item.pic_url)
        }
      }
    }) : _vm._e()]) : _vm._e(), _vm._v(" "), (item.module == 'notice') ? _c('div', {
      staticClass: "chat_info"
    }, [_c('span', {
      staticClass: "name"
    }, [_vm._v(_vm._s(item.nick) + ":")]), _vm._v(" "), _c('span', {
      directives: [{
        name: "dompurify-html",
        rawName: "v-dompurify-html",
        value: (item.content),
        expression: "item.content"
      }],
      staticClass: "chat_text"
    })]) : _vm._e()])]) : _vm._e()])
  }), 0)])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-dbe8ab8c"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Modular/Vertical/chatlist.vue
// module id = 516
// module chunks = 0